/* Copyright (c) 2018 Scaper */

import firebase from "@firebase/app";
import "@firebase/auth";
import "@firebase/firestore";
import "@firebase/functions";
import { Dispatch } from "redoodle";
import { IAppState } from "../app/appState";
import { PlaceService } from "./placeService";
import { UserService } from "./userService";

function initializeFirebaseApp() {
    firebase.initializeApp({
        apiKey: "AIzaSyC225kJwpyNxFGNWph60k_VmIdc8xQKWRs",
        authDomain: "scaper-11bcb.firebaseapp.com",
        databaseURL: "https://scaper-11bcb.firebaseio.com",
        projectId: "scaper-11bcb",
        storageBucket: "scaper-11bcb.appspot.com",
        messagingSenderId: "974362355155"
    });
}

export type AuthType = Exclude<typeof firebase.auth, undefined>;
export type FirestoreType = Exclude<typeof firebase.firestore, undefined>;
export type FunctionsType = Exclude<typeof firebase.functions, undefined>;

export interface IApi {
    auth: AuthType;
    placeService: PlaceService,
    userService: UserService,
}

export function createApi(dispatch: Dispatch, getState: () => IAppState): IApi {
    initializeFirebaseApp();

    const auth = firebase.auth!;
    const firestore = firebase.firestore!;
    firestore().settings({ timestampsInSnapshots: true });
    const functions = firebase.functions!;

    const placeService = new PlaceService(dispatch, getState, functions);
    const userService = new UserService(dispatch, auth, firestore, functions);
    return { auth, placeService, userService };
}
